import { useEffect, useState } from 'react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 600);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={scrollTop}
      aria-label="返回顶部"
      className="fixed bottom-6 right-4 md:right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-950 text-xl text-background-50 transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line" aria-hidden="true" />
    </button>
  );
}